import React, { FC } from 'react'
import classNames from 'classnames'
import { Button } from '@/atoms/Button'
import { CaptionXS, EyebrowSM, LabelSM } from '@/atoms/Text'
import { useThemeContext } from '@/contexts/ThemeContext'
import { useTranslate } from '@/utils/translate/translate-client'

interface GroupTicketsButtonProps {
  onClick: () => void
}
const GroupTicketsButton: FC<GroupTicketsButtonProps> = ({ onClick }) => {
  const { t } = useTranslate('tickets')
  const { isDarkMode } = useThemeContext()
  const lightModeVariant = 'core-gray-800'
  return (
    <Button
      onClick={onClick}
      className={classNames(
        'relative flex h-10 shrink-0 items-center justify-center gap-2 rounded-[8px] px-3 py-3 hover:scale-105',
        !isDarkMode && 'border border-core-gray-200',
      )}
      variant={isDarkMode ? 'white' : lightModeVariant}
    >
      <LabelSM weight="medium"> {t('groupDiscount', 'Group Discount')}</LabelSM>
    </Button>
  )
}

export const GroupTicketsButtonWrapper: FC<GroupTicketsButtonProps> = (props) => {
  const { t } = useTranslate('tickets')

  return (
    <div className="mt-auto flex items-center gap-4 border-t border-core-gray-300 pt-4">
      <div className="flex flex-col gap-0.5">
        <EyebrowSM weight="bold">{t('saveWhenYouBringAGroup', 'Save when you bring a group')}</EyebrowSM>
        <CaptionXS color="core-gray-700">
          {t('idealForFamiliesFriendsAndLargerGroups', 'Ideal for families, friends and larger groups.')}
        </CaptionXS>
      </div>
      <GroupTicketsButton {...props} />
    </div>
  )
}

export default GroupTicketsButton
